const ApiConfig = {
  api_base_url: "https://api.alero.africa/v1/",
  api_media_url: "https://api.alero.africa//media/",
  // api_base_url: "http://127.0.0.1:8000/v1/",
  // api_media_url: "http://127.0.0.1:8000/media/",
};

export default ApiConfig;
